import cicloMenstrualImg from '../../assets/ciclo_menstrual.jpeg';

const MenstrualCycle = () => {
    return (
        <div className='educative-info-section'>
            <div className='educative-container'>
                <header className='educative-header'>
                    <h1 className='educative-main-title'>Las fases del ciclo menstrual</h1>
                    <p className='educative-subtitle'>Conoce los cambios y etapas que vive tu cuerpo cada mes</p>
                </header>
                <div className='educative-text-box-container educative-info-textarea' style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <section>
                        <strong>Las cuatro fases principales del ciclo menstrual</strong> son la menstruación (desprendimiento del revestimiento uterino), la fase folicular (preparación de un nuevo óvulo), la ovulación (liberación del óvulo) y la fase lútea (preparación del cuerpo para un posible embarazo si el óvulo es fertilizado). Cada una de estas etapas implica cambios hormonales y fisiológicos en el cuerpo para prepararse para un posible embarazo.
                    </section>
                    <img src={cicloMenstrualImg} alt='Ciclo menstrual' style={{ width: '100%', maxWidth: 400, alignSelf: 'center', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }} />
                    <section>
                        <h3>1. Menstruación</h3>
                        <ul>
                            <li><b>Qué sucede:</b> El revestimiento del útero (endometrio) se desprende y se expulsa del cuerpo en forma de sangrado.</li>
                            <li><b>Duración:</b> Generalmente dura de 3 a 7 días.</li>
                            <li><b>Hormonas:</b> Los niveles de estrógeno y progesterona son bajos durante esta fase.</li>
                        </ul>
                    </section>
                    <section>
                        <h3>2. Fase folicular</h3>
                        <ul>
                            <li><b>Qué sucede:</b> Esta fase comienza el primer día de la menstruación y se superpone con ella. Los folículos en los ovarios se desarrollan, y uno de ellos madura hasta convertirse en el folículo dominante que contiene el óvulo. Al mismo tiempo, el revestimiento uterino comienza a reconstruirse.</li>
                            <li><b>Duración:</b> La duración de esta fase puede variar, pero en un ciclo promedio de 28 días, va aproximadamente del día 1 al día 14.</li>
                            <li><b>Hormonas:</b> La hormona foliculoestimulante (FSH) estimula el crecimiento de los folículos y el aumento de los niveles de estrógeno.</li>
                        </ul>
                    </section>
                    <section>
                        <h3>3. Ovulación</h3>
                        <ul>
                            <li><b>Qué sucede:</b> El folículo dominante libera el óvulo maduro desde el ovario.</li>
                            <li><b>Duración:</b> Ocurre alrededor del día 14 de un ciclo de 28 días.</li>
                            <li><b>Hormonas:</b> Un pico de la hormona luteinizante (LH) desencadena la ovulación.</li>
                        </ul>
                    </section>
                    <section>
                        <h3>4. Fase lútea</h3>
                        <ul>
                            <li><b>Qué sucede:</b> Después de la ovulación, el folículo dominante se transforma en el cuerpo lúteo, que produce progesterona y estrógeno para preparar el revestimiento del útero para un posible embarazo.</li>
                            <li><b>Duración:</b> Suele ser la fase más estable del ciclo, durando aproximadamente 14 días.</li>
                            <li><b>Hormonas:</b> La progesterona aumenta para preparar el útero. Si no hay fertilización, el cuerpo lúteo se degenera, los niveles de hormonas caen y comienza la menstruación, iniciando un nuevo ciclo.</li>
                        </ul>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default MenstrualCycle;
